module.exports = __webpack_public_path__ + "img/poster_Native_Artifactory_Integration_R3.716ec19a.jpg";